import type { ReactNode, RefObject } from 'react';
import { Card, CardContent } from '@shared/components';

interface Props {
    panelLabel: string;
    panelRef?: RefObject<HTMLElement | null>;
    panel: ReactNode;
    services: ReactNode;
    addOns: ReactNode;
}

export function InvoiceSelectionLayout({ panelLabel, panelRef, panel, services, addOns }: Props) {
    return (
        <div className="grid gap-4 @min-[58rem]:grid-cols-[minmax(0,1fr)_20rem] @min-[58rem]:items-start">
            <aside ref={panelRef} aria-label={panelLabel} className="@min-[58rem]:sticky @min-[58rem]:top-5 @min-[58rem]:col-start-2 @min-[58rem]:row-start-1">
                {panel}
            </aside>

            <div className="min-w-0 space-y-4 @min-[58rem]:col-start-1 @min-[58rem]:row-start-1">
                <Card>
                    <CardContent>{services}</CardContent>
                </Card>

                <Card>
                    <CardContent>{addOns}</CardContent>
                </Card>
            </div>
        </div>
    );
}
